import React from 'react';
import styled from 'styled-components';
import { basicColor } from '@/styles/template';

interface DottedLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	white?: boolean;
}

const DottedLink = styled.a<DottedLinkProps>`
  cursor: pointer;
  width: fit-content;
  display: inline-block;
  color: ${(props) => (props.white ? basicColor.white : basicColor.primary)};
  border-bottom: 2px dotted ${(props) => (props.white ? basicColor.white : basicColor.primary)};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0 1rem;
  max-width: 100%;
`;

export default DottedLink;